/**
 *    Map filter
 */

(function ($) {
  Drupal.behaviors.mapAreaSearch = {
    filter(map) {
      const $inputLat = $('#edit-lat');
      const $inputLng = $('#edit-lng');
      const $areaSearchRadios = $('#vb-fieldset--area-search').find('.vb-field__input');
      const $areaSearchInput = $('#edit-geo-location-proximity');
      const marker = new google.maps.Marker({
        map,
        title: 'POI',
      });
      const circle = new google.maps.Circle({
        map,
        radius: parseInt($areaSearchInput.val()) * 1000,
        strokeColor: '#298cb5',
        strokeWeight: '1',
        fillColor: '#298cb5',
        fillOpacity: '.1',
        clickable: false,
      });

      // slider numeric input
      $areaSearchInput.on('change', function () {
        const radius = parseInt(this.value) * 1000;

        // reprint radius of the circle
        circle.setRadius(radius);
      });

      // radio button change
      $areaSearchRadios.on('change', function () {
        if (!$(this).is(':checked')) {
          return false;
        }
        const value = JSON.parse(this.value);
        const newPosition = new google.maps.LatLng(value.lat, value.lng);

        // set new position
        marker.setPosition(newPosition);
        marker.setIcon({
          url: `./themes/custom/vb2016/components/meeting-guide/map/assets/markers/marker-${value.icon}.svg`,
          scaledSize: new google.maps.Size(30, 30),
          anchor: new google.maps.Point(15, 15),
        });

        // fill hidden inputs
        $inputLat.val(value.lat);
        $inputLng.val(value.lng);

        // focus new area
        map.panTo(newPosition);

        // draw circle
        circle.bindTo('center', marker, 'position');

        // if at least one input is checked
        if (radioInputIsChecked($areaSearchRadios)) {
          // add 'checked' class
          $areaSearchRadios.closest('.vb-map-area-search').addClass('vb-checked');
          // show marker
          marker.setVisible(true);
          // show circle
          circle.setVisible(true);
        } else {
          // remove 'checked' class
          $areaSearchRadios.closest('.vb-map-area-search').removeClass('vb-checked');
          // hide marker
          marker.setVisible(false);
          // hide circle
          circle.setVisible(false);
        }
      });

      // return true or false
      function radioInputIsChecked($radios) {
        let status = false;

        $radios.each((index, element) => {
          if ($(element).is(':checked')) {
            status = true;
          }
        });

        return status;
      }

      // open/close button
      const $buttonAreaSearchToggle = $('.vb-map-area-search__button--toggle');
      $buttonAreaSearchToggle.on('click', function () {
        const $button = $(this);
        const $body = $(document.body);
        const $wrapper = $button.closest('.vb-map-area-search');
        const $content = $wrapper.find('.vb-map-area-search__content');

        // toggle class
        $body.toggleClass('vb-meeting-guide--area-search');
        $wrapper.toggleClass('vb-open');

        // toggle aria attribute
        if ($wrapper.hasClass('vb-open')) {
          $content.attr('aria-hidden', false);
        } else {
          $content.attr('aria-hidden', true);
        }
      });

      // range slider
      const $sliderAreaSearch = $('.vb-field__slider--range-area-distances');
      const $areaSearchDropdown = $sliderAreaSearch.closest('.vb-map-area-search');
      $sliderAreaSearch
        .on('mousedown touchstart', () => {
          $areaSearchDropdown.addClass('vb-sliding');
        })
        .on('mouseup touchend', () => {
          $areaSearchDropdown.removeClass('vb-sliding');
        });

      // mouseup outside slider
      $(document).on('mouseup', () => {
        $areaSearchDropdown.removeClass('vb-sliding');
      });

      // reset button
      const $sliderAreaSearchResetButton = $('.vb-map-area-search__button--reset');
      $sliderAreaSearchResetButton.on('click', () => {
        // reset form styling
        $sliderAreaSearchResetButton.closest('.vb-map-area-search').removeClass('vb-checked');

        // uncheck all radio buttons
        $areaSearchRadios.each((index, element) => {
          $(element).prop('checked', false).trigger('change');
        });
      });

      // submit button
      const $sliderAreaSearchSubmitButton = $('.vb-map-area-search__button--submit');
      $sliderAreaSearchSubmitButton.on('click', () => {
        // submit target form
        $('.vb-filter-bar__button--submit').trigger('click');

        // mobile?
        if (
          Foundation.MediaQuery.current === 'small'
                  || Foundation.MediaQuery.current === 'medium'
        ) {
          // hide map
          setTimeout(() => {
            $('#vb-field--toggle-map').trigger('change');
          }, 300);
        }
      });

      // on load: check radio
      $areaSearchRadios.each((index, element) => {
        const $radio = $(element);
        const value = JSON.parse($radio.val());

        if (value.lat === $inputLat.val()) {
          $radio.prop('checked', true).trigger('change');
        }
      });
    },
  };
}(jQuery));

// end of map-filter.js
